import React from 'react';
import PropTypes from 'prop-types';
import './QesCooldownFillButton.css';

/**
 * Fill button that can show a left→right cooldown fill before becoming clickable.
 * Used e.g. SignMe signature status-check Restart (give poll a moment first).
 *
 * Shadow lives on the wrapper — the inner button uses overflow:hidden for the
 * fill animation, which would otherwise clip box-shadow.
 */
export default function QesCooldownFillButton({
  id,
  children,
  cooling,
  disabled,
  onClick,
  durationMs = 5000,
  style
}) {
  const inactive = Boolean(disabled || cooling);

  return (
    <span className="qes-cooldown-fill-btn-wrap" style={style}>
      <button
        type="button"
        id={id}
        className={
          cooling
            ? 'qes-cooldown-fill-btn qes-cooldown-fill-btn--cooling'
            : 'qes-cooldown-fill-btn'
        }
        style={{ '--qes-cooldown-ms': `${durationMs}ms` }}
        disabled={inactive}
        aria-disabled={inactive}
        onClick={inactive ? undefined : onClick}
      >
        <span className="qes-cooldown-fill-btn__fill" aria-hidden="true" />
        <span className="qes-cooldown-fill-btn__label">{children}</span>
      </button>
    </span>
  );
}

QesCooldownFillButton.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  cooling: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  durationMs: PropTypes.number,
  style: PropTypes.object
};
